import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RespondentListApi } from '../../api/respondent-list/respondent-list.api';

@Injectable({ providedIn: 'root' })
export class RespondentListService {
  private readonly _api = inject(RespondentListApi);

  public upload(surveyId: number, file: File): Observable<string[]> {
    return this._api.upload(surveyId, file);
  }

  public getUploadedList(
    surveyId: number,
    inclExcl: 0 | 1,
  ): Observable<string[]> {
    return this._api.getUploadedList(surveyId, inclExcl);
  }

  public clear(surveyId: number): Observable<void> {
    return this._api.clear(surveyId);
  }
}
